import React from 'react'
import PropTypes from 'prop-types'
import CSVError from './LmsCSVError.jsx'
import {
  BodyCopy,
  DownloadIcon,
  SpinnerAnimatedIcon,
} from 'secondstep-components'
import {
  CsvTooltip,
  CsvWrapper,
  LabelWrapper,
  StyledCsvDownloadMenu,
} from './component.styles.js'
import { CSV_DOWNLOAD_LABEL, DOWNLOAD_LINK_TEXT } from './constants'

const CSVReportsDropdown = ({
  classesCount,
  error,
  historicalReports,
  historicalReportingOnClick,
  isFetching,
  lessonReportingOnClick,
  onClickCurrentYear,
  schoolCsvDownloadTooltip,
  excludeLabels = false,
  buttonText = DOWNLOAD_LINK_TEXT,
}) => {
  if (error) {
    return <CSVError />
  }

  const shouldShowCsvMenu = !!(classesCount > 0 || historicalReports) && !error

  if (!shouldShowCsvMenu) {
    return null
  }

  return (
    <CsvWrapper>
      {!excludeLabels && (
        <LabelWrapper>
          <label htmlFor="csv-download">{CSV_DOWNLOAD_LABEL}</label>
          <CsvTooltip content={<BodyCopy>{schoolCsvDownloadTooltip}</BodyCopy>}>
            <i className="fas fa-question-circle" />
          </CsvTooltip>
        </LabelWrapper>
      )}
      <StyledCsvDownloadMenu
        buttonIcon={isFetching ? SpinnerAnimatedIcon : DownloadIcon}
        buttonText={buttonText}
        dataTestId="select-csv"
        disabledSelectButton={isFetching}
        hasScrollableHistoricalReports={true}
        historicalReports={historicalReports}
        name="csv-download"
        onClickCurrent={lessonReportingOnClick}
        onClickCurrentYear={onClickCurrentYear}
        onClickHistorical={historicalReportingOnClick}
        showDownloadIcons={false}
        showLoadingText={false}
      />
    </CsvWrapper>
  )
}

CSVReportsDropdown.propTypes = {
  buttonText: PropTypes.string,
  classesCount: PropTypes.number,
  error: PropTypes.object,
  excludeLabels: PropTypes.bool,
  historicalReportingOnClick: PropTypes.func,
  historicalReports: PropTypes.array,
  isFetching: PropTypes.bool,
  isFetchingDocumentUrl: PropTypes.bool,
  isFetchingHistoricalReportData: PropTypes.bool,
  lessonReportingOnClick: PropTypes.func,
  onClickCurrentYear: PropTypes.func,
  schoolCsvDownloadTooltip: PropTypes.string,
}

export default CSVReportsDropdown
